import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { trackAnalytics } from "../../utils/analytics";

const cartItemKey = (item) =>
  `${item?._id || item?.id || item?.product_id || ""}-${item?.variant_id || item?.product_variant_id || ""}-${item?.color || ""}-${item?.size || ""}`;

const AnalyticsTracker = () => {
  const location = useLocation();
  const cart = useSelector((state) => state.cartReducer?.cart || []);
  const previousCartRef = useRef(null);
  const lastPathRef = useRef("");

  useEffect(() => {
    const key = `${location.pathname}${location.search}`;

    if (lastPathRef.current === key) {
      return;
    }

    lastPathRef.current = key;
    trackAnalytics("page_view");
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (previousCartRef.current === null) {
      previousCartRef.current = cart;
      return;
    }

    const previousMap = new Map(
      previousCartRef.current.map((item) => [cartItemKey(item), Number(item.quantity || 0)])
    );

    const addedItem = cart.find((item) => {
      const previousQuantity = previousMap.get(cartItemKey(item)) || 0;
      return Number(item.quantity || 0) > previousQuantity;
    });

    if (addedItem) {
      trackAnalytics("add_to_cart", {
        product_id: addedItem._id || addedItem.id || addedItem.product_id || null,
        metadata: {
          product_name: addedItem.title || addedItem.name || "",
          quantity: Number(addedItem.quantity || 1),
          color: addedItem.color || "",
          size: addedItem.size || "",
          price: Number(addedItem.sale_price || addedItem.final_price || addedItem.price || 0)
        }
      });
    }

    previousCartRef.current = cart;
  }, [cart]);

  return null;
};

export default AnalyticsTracker;
